exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\n  background-color: #e8e8e8;\n}\n.navbar-brand{\n  padding-left: 10px;\n  font-size: 30px;\n  margin-right: 50px;\n}\n.nav-item {\n  padding: 0 25px;\n}\n#logo{\n  height: 90px;\n  width: auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/nurture/src/app/navbar/navbar.component.css
// module id = ../../../../../src/app/navbar/navbar.component.css
// module chunks = main